import { createAction } from '@reduxjs/toolkit';
import {
  CREATE_MANUAL_RECORD_ERROR,
  CREATE_MANUAL_RECORD_SUCCESS,
  DELETE_MANUAL_RECORD_ERROR,
  DELETE_MANUAL_RECORD_SUCCESS,
  UPDATE_MANUAL_RECORD_ERROR,
  UPDATE_MANUAL_RECORD_SUCCESS,
} from './constants';

export const createManualRecordSuccessAction = createAction(CREATE_MANUAL_RECORD_SUCCESS);
export const createManualRecordErrorAction = createAction(CREATE_MANUAL_RECORD_ERROR);

export const deleteManualRecordSuccessAction = createAction(DELETE_MANUAL_RECORD_SUCCESS);
export const deleteManualRecordErrorAction = createAction(DELETE_MANUAL_RECORD_ERROR);

export const updateManualRecordSuccessAction = createAction(UPDATE_MANUAL_RECORD_SUCCESS);
export const updateManualRecordErrorAction = createAction(UPDATE_MANUAL_RECORD_ERROR);
